// sync with console:/staticContent/assets/js/main.js
export function seasonClassFor(now: Date) {
	let suffix = 'regular'
	if (!now) return `season-${suffix}`;

	const month = now.getMonth();

	if ([6,7].includes(month))
		suffix = 'summer';

	else if ([0, 1, 11].includes(month))
		suffix = 'winter'

	else if (now > new Date(`${now.getFullYear()}-10-20`) && now < new Date(`${now.getFullYear()}-11-03`))
		suffix = 'Halloween'

	else if (now > new Date(`${now.getFullYear()}-09-22`) && now < new Date(`${now.getFullYear()}-12-03`))
		suffix = 'autumn'

	else if ([8].includes(month))
		suffix = 'fall';

	return `season-${suffix.toLowerCase()}`;
}

export function seasonClass() {
	return seasonClassFor(new Date());
}
